import { Button, StatusMessage, Text } from '@s7/ui-kit';
import classNames from 'classnames/bind';
import React, { useEffect } from 'react';
import styles from './BlockScreen.css';
import { getBlockScreenTitle, getTwoFactorAnalyticBlockType, getTwoFactorAnalyticEvent } from '../Login/utils';
import { useAnalyticsContext } from '../utils/analytics';
var cx = classNames.bind(styles);

var getBlockScreenData = function getBlockScreenData(dictionary, onClickRetryButton, onClickCallButton) {
  return {
    permanent: {
      view: 'error',
      button: /*#__PURE__*/React.createElement(Button, {
        as: 'a',
        classes: {
          root: cx('button')
        },
        href: 'tel:8 800 700–90-10',
        onClick: onClickCallButton,
        theme: 'b2c'
      }, /*#__PURE__*/React.createElement(Text, {
        color: 'W100'
      }, dictionary.t('com.login.2fa.call')))
    },
    temporary: {
      view: 'warning',
      button: /*#__PURE__*/React.createElement(Button, {
        classes: {
          root: cx('button')
        },
        onClick: onClickRetryButton,
        theme: 'b2c'
      }, dictionary.t('com.login.2fa.retry'))
    }
  };
};

export var BlockScreen = function BlockScreen(_ref) {
  var _ref$loginBlockState = _ref.loginBlockState,
      blockType = _ref$loginBlockState.blockType,
      message = _ref$loginBlockState.message,
      dictionary = _ref.dictionary,
      setLoginBlockState = _ref.setLoginBlockState,
      setTwoFactorDetails = _ref.setTwoFactorDetails,
      isDesktop = _ref.isDesktop;

  var onClickRetryButton = function onClickRetryButton() {
    sendEvent(getTwoFactorAnalyticEvent({
      event_name: 'click_cta',
      step: getTwoFactorAnalyticBlockType(blockType),
      result: 'try_again'
    }));
    setLoginBlockState(null);
    setTwoFactorDetails(null);
  };

  var onClickCallButton = function onClickCallButton() {
    sendEvent(getTwoFactorAnalyticEvent({
      event_name: 'click_cta',
      step: getTwoFactorAnalyticBlockType(blockType),
      result: 'call'
    }));
  };

  var data = getBlockScreenData(dictionary, onClickRetryButton, onClickCallButton);
  var _data$blockType = data[blockType],
      view = _data$blockType.view,
      button = _data$blockType.button;

  var _useAnalyticsContext = useAnalyticsContext(),
      sendEvent = _useAnalyticsContext.sendEvent;

  useEffect(function () {
    sendEvent(getTwoFactorAnalyticEvent({
      event_name: 'screen_view',
      step: getTwoFactorAnalyticBlockType(blockType)
    }));
  }, [blockType]);
  return /*#__PURE__*/React.createElement("div", {
    className: cx('block-wrapper')
  }, /*#__PURE__*/React.createElement(StatusMessage, {
    id: blockType,
    title: !isDesktop && getBlockScreenTitle(blockType, dictionary),
    view: view
  }, message), button);
};